import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { TESTIMONIALS } from "@/lib/deptContent";

function Edit() {
  const { id } = Route.useParams();
  return <DeptContentForm cfg={TESTIMONIALS} id={id} />;
}

export const Route = createFileRoute("/_app/departments/testimonials/$id")({
  component: Edit,
});
